import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bs-page-table-wrapper" }
const _hoisted_2 = { class: "bs-page-table-wrapper__header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "header__actions" }
const _hoisted_5 = { class: "bs-page-table-wrapper__footer-top" }
const _hoisted_6 = { class: "footer__pagination" }
const _hoisted_7 = { class: "pagination__limit" }
const _hoisted_8 = { class: "pagination__items" }
const _hoisted_9 = { class: "footer__additional" }
const _hoisted_10 = { class: "bs-page-table-wrapper__container" }
const _hoisted_11 = {
  key: 0,
  class: "container__state"
}
const _hoisted_12 = { class: "state__message" }
const _hoisted_13 = { class: "state__message message--failed" }
const _hoisted_14 = {
  key: 2,
  class: "state__message"
}
const _hoisted_15 = { class: "bs-page-table-wrapper__footer" }
const _hoisted_16 = { class: "footer__pagination" }
const _hoisted_17 = { class: "pagination__limit" }
const _hoisted_18 = { class: "pagination__items" }
const _hoisted_19 = { class: "footer__additional" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_select = _resolveComponent("bs-select")!
  const _component_bs_pagination = _resolveComponent("bs-pagination")!
  const _component_bs_loader = _resolveComponent("bs-loader")!
  const _component_bs_button = _resolveComponent("bs-button")!
  const _component_bs_h_scroll_container = _resolveComponent("bs-h-scroll-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "actions")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.pagination)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (Boolean(_ctx.limit))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createTextVNode(" Показано "),
                      _createVNode(_component_bs_select, {
                        placeholder: "Лимит",
                        "model-value": _ctx.limit,
                        options: _ctx.limits,
                        disabled: _ctx.disabled || _ctx.loading,
                        "select-by": "value",
                        onChange: _ctx.onUpdateLimit
                      }, null, 8, ["model-value", "options", "disabled", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.itemsShown) + " из " + _toDisplayString(_ctx.totalItems), 1)
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_bs_pagination, {
                "model-value": _ctx.page,
                "total-pages": _ctx.totalPages,
                disabled: _ctx.disabled || _ctx.loading,
                onChange: _ctx.onUpdatePage
              }, null, 8, ["model-value", "total-pages", "disabled", "onChange"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.$slots['footer'])
          ? _renderSlot(_ctx.$slots, "footer", { key: 0 })
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.loading || _ctx.failed || _ctx.empty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.loadingText), 1),
                  _createVNode(_component_bs_loader)
                ], 64))
              : (_ctx.failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.failedText), 1),
                    _createVNode(_component_bs_button, {
                      color: "royal-blue",
                      onClick: _ctx.onRefresh
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.refreshText), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : (_ctx.empty)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.emptyText), 1))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock(_component_bs_h_scroll_container, { key: 1 }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }))
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        (_ctx.pagination)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (Boolean(_ctx.limit))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_17, [
                      _createTextVNode(" Показано "),
                      _createVNode(_component_bs_select, {
                        placeholder: "Лимит",
                        "model-value": _ctx.limit,
                        options: _ctx.limits,
                        disabled: _ctx.disabled || _ctx.loading,
                        "select-by": "value",
                        onChange: _ctx.onUpdateLimit
                      }, null, 8, ["model-value", "options", "disabled", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.itemsShown) + " из " + _toDisplayString(_ctx.totalItems), 1)
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_bs_pagination, {
                "model-value": _ctx.page,
                "total-pages": _ctx.totalPages,
                disabled: _ctx.disabled || _ctx.loading,
                onChange: _ctx.onUpdatePage
              }, null, 8, ["model-value", "total-pages", "disabled", "onChange"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        (_ctx.$slots['footer'])
          ? _renderSlot(_ctx.$slots, "footer", { key: 0 })
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}